import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CssFileIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CssFile",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M4.31 24.39h2.8v1.87c0 2.2 1.73 3.74 4.21 3.74h14.02c2.47 0 4.21-1.54 4.21-3.74V10.55c-.03-.12-.07-.24-.12-.34s0-.07 0-.07c-.06-.11-.14-.21-.22-.3l-7.55-7.5c-.08-.08-.18-.16-.29-.22s-.08 0-.08 0c-.1-.05-.21-.09-.33-.11s-9.63 0-9.63 0c-2.31 0-4.18 1.86-4.21 4.16v7.95h-2.8c-1.03 0-1.87.84-1.87 1.87v6.54c0 1.03.84 1.87 1.87 1.87Zm2.8-8.41h1.4a.49.49 0 0 1 0 .98H6.17v4.67h2.34a.49.49 0 0 1 0 .98h-2.8a.47.47 0 0 1-.47-.47v-5.69c0-.26.21-.47.47-.47zm13.09.47c0 .26-.21.47-.47.47h-2.34v1.87h2.34c.26 0 .47.21.47.47v2.8c0 .26-.21.47-.47.47h-2.8a.49.49 0 0 1 0-.98h2.34v-1.83h-2.34a.47.47 0 0 1-.47-.47v-2.8c0-.26.21-.47.47-.47h2.8c.26 0 .47.21.47.47m-5.61 0c0 .26-.21.47-.47.47h-2.34v1.87h2.34c.26 0 .47.21.47.47v2.8c0 .26-.21.47-.47.47h-2.8a.49.49 0 0 1 0-.98h2.34v-1.83h-2.34a.47.47 0 0 1-.47-.47v-2.8c0-.26.21-.47.47-.47h2.84c.26 0 .47.21.47.47s-.04 0-.04 0M9.92 6.17c0-.77.63-1.4 1.4-1.4h7.95v5.14c0 1.29 1.05 2.34 2.34 2.34h5.14v14.02c0 .77-.76.97-1.4.97H11.33c-.64 0-1.4-.17-1.4-.97V24.4h11.22c1.03 0 1.87-.84 1.87-1.87v-6.54c0-1.03-.84-1.87-1.87-1.87H9.93V6.17Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M8.56 25.02c0-2.57 1.95-4.47 4.63-4.47.76 0 1.58.2 2.2.58v2.15c-.56-.42-1.27-.69-2.07-.69-1.36 0-2.48.92-2.48 2.43s1.11 2.43 2.48 2.43c.78 0 1.52-.27 2.07-.7v2.15c-.62.38-1.44.58-2.2.58-2.68 0-4.63-1.9-4.63-4.47ZM16.31 28.64v-2.15c.91.68 1.97 1.06 2.89 1.06.79 0 1.3-.27 1.3-.73 0-.34-.22-.58-.81-.75l-1.39-.4c-1.32-.37-2.06-1.16-2.06-2.39 0-1.6 1.4-2.73 3.27-2.73 1.07 0 1.85.22 2.66.66v2.1c-1-.57-1.89-.81-2.57-.81s-1.1.25-1.1.65c0 .3.22.52.63.65l1.23.36c1.4.41 2.38 1.14 2.38 2.63 0 1.62-1.38 2.71-3.42 2.71-1.11 0-2.18-.3-3.02-.84ZM23.41 28.64v-2.15c.91.68 1.97 1.06 2.89 1.06.79 0 1.3-.27 1.3-.73 0-.34-.22-.58-.81-.75l-1.39-.4c-1.32-.37-2.06-1.16-2.06-2.39 0-1.6 1.4-2.73 3.27-2.73 1.07 0 1.85.22 2.66.66v2.1c-1-.57-1.89-.81-2.57-.81s-1.1.25-1.1.65c0 .3.22.52.63.65l1.23.36c1.4.41 2.38 1.14 2.38 2.63 0 1.62-1.38 2.71-3.42 2.71-1.11 0-2.18-.3-3.02-.84Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.29 29.29c-1.89 0-3.43-1.54-3.43-3.43V5.29c0-1.89 1.54-3.43 3.43-3.43H19c.3 0 .59.12.81.33l9.14 9.14c.45.45.45 1.17 0 1.62s-1.17.45-1.62 0l-8.81-8.81H5.29c-.63 0-1.14.51-1.14 1.14v20.57c0 .63.51 1.14 1.14 1.14a1.14 1.14 0 1 1 0 2.28Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M28.14 17.86c-.63 0-1.14-.51-1.14-1.14v-3.43h-5.71c-1.89 0-3.43-1.54-3.43-3.43V3a1.14 1.14 0 1 1 2.28 0v6.86c0 .63.51 1.14 1.14 1.14h6.86c.63 0 1.14.51 1.14 1.14v4.57c0 .63-.51 1.14-1.14 1.14Z"
      })]
    })
  }));
};